<template>
  <div >
    <b-spinner v-if="loading" variant="success" label="Spinning"></b-spinner>
    <table v-if="!loading && horse" class="table table-responsive">
      <thead >
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Skill</th>
          <th scope="col">Change</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(skillEntry,i) in horse.skillHistory">
          <td>{{skillEntry.dateMoment}}</td>
          <td>{{skillEntry.skill.toFixed(2)}}</td>
          <td :class="getChange(i) === '-'? '': getChange(i) * 1 > 0? 'green':'red'">{{getChange(i)}}</td>
        </tr>
      </tbody>
    </table>
    <b-button>Full History</b-button>
  </div>
</template>

<script>
import {getHorse} from '../clients/HorsesClient'
import moment from 'moment'
export default {
  name: 'HorseScoresTable',
  props:   {
    horseName: String,
    raceType: String
  },
  components: {
  },
  data () {
    return {
      horse: undefined,
      loading: false
    }
  },
  watch: {
    horseName: function() {
      this.loadHorse()
    }
  },
  methods: {
    loadHorse: async function() {
      this.loading = true
      this.horse = await getHorse(this.horseName, this.raceType)
      if (!this.horse) this.horse = {skillHistory:[]}
      this.horse.skillHistory.sort((a,b) => b.date - a.date)
      for (let obj of this.horse.skillHistory) {
        obj.dateMoment = moment(`${obj.date}`).format("DD-MMM-YYYY")
      }
      this.loading = false
    },
    getChange: function(i) {
      if (i === this.horse.skillHistory.length - 1) return '-'
      return (this.horse.skillHistory[i].skill - this.horse.skillHistory[i+1].skill).toFixed(2)
    }
  },
  mounted () {
    this.loadHorse()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}

.green {
  background-color: green;
}

.red {
  background-color: #9f2a2a;
}
</style>
